import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: config.AuthPassword || "Auth/password",
        method: "POST",
        body: credentials,
      }),
    }),
    validateUser: builder.mutation({
      query: (data) => ({
        url: config.ValidateUser,
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data?.token) {
            localStorage.setItem("token", data.token);
          }
        } catch (err) {}
      },
    }),
    refreshToken: builder.mutation({
      query: (refreshToken) => ({
        url: config.AuthRefresh || "Auth/refresh",
        method: "POST",
        body: { refreshToken },
      }),
    }),
    getUserDetails: builder.query({
      query: (id) => `${config.GetUser}${id}`,
      providesTags: ["User"],
    }),
    getPartnerUserDetails: builder.query({
      query: (id) => `${config.GetUser}${id}`,
      providesTags: ["User"],
    }),
    updateLoginLogoutStatus: builder.mutation({
      query: (refreshToken) => ({
        url: config.AuthLogout || "Auth/logout",
        method: "POST",
        body: { refreshToken },
      }),
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {}
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("userType");
      },
    }),
    addHostDetails: builder.mutation({
      query: (data) => ({
        url: config.AddHostDetails,
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data) {
            localStorage.setItem("hostId", data);
          }
        } catch (err) {}
      },
    }),
    getUserProfilePic: builder.query({
      query: (id) => ({
        url: `${config.GetProfilePicData}${id}`,
        responseHandler: "text",
      }),
      providesTags: ["User"],
    }),
    getUserProfileLogo: builder.query({
      query: (id) => ({
        url: `${config.GetCompanyLogData}${id}`,
        responseHandler: "text",
      }),
      providesTags: ["User"],
    }),
    updateProfileData: builder.mutation({
      query: (data) => ({
        url: config.UpdateProfileData,
        method: "POST",
        body: data,
        responseHandler: "text",
      }),
      invalidatesTags: ["User"],
    }),
    uploadProfilePic: builder.mutation({
      query: (data) => ({
        url: config.UploadProfilePic,
        method: "POST",
        body: data,
        responseHandler: "text",
      }),
      invalidatesTags: ["User"],
    }),
    uploadCompanyLogo: builder.mutation({
      query: (data) => ({
        url: config.UploadCompanyLogo,
        method: "POST",
        body: data,
        responseHandler: "text",
      }),
      invalidatesTags: ["User"],
    }),
    updateLoginStatus: builder.query({
      query: (id) => `${config.UpdateLoginStatus}${id}`,
    }),
    sendSecurityCodeToEmail: builder.query({
      query: ({ username, email }) => ({
        url: `${config.SendSecurityCodeToEmail}${username}&email=${email}`,
        responseHandler: "text",
      }),
    }),
    verifySecurityCode: builder.query({
      query: ({ email, code, type = "identity" }) => ({
        url: `${config.VerifySecurityCode}${email}&code=${code}&type=${type}`,
        responseHandler: "text",
      }),
    }),
    getClientDetails: builder.query({
      query: () => config.GetClientDetails,
    }),
  }),
});

export const {
  useLoginMutation,
  useValidateUserMutation,
  useRefreshTokenMutation,
  useGetUserDetailsQuery,
  useLazyGetUserDetailsQuery,
  useGetPartnerUserDetailsQuery,
  useLazyGetPartnerUserDetailsQuery,
  useUpdateLoginLogoutStatusMutation,
  useAddHostDetailsMutation,
  useGetUserProfilePicQuery,
  useLazyGetUserProfilePicQuery,
  useGetUserProfileLogoQuery,
  useLazyGetUserProfileLogoQuery,
  useUpdateProfileDataMutation,
  useUploadProfilePicMutation,
  useUploadCompanyLogoMutation,
  useLazyUpdateLoginStatusQuery,
  useLazySendSecurityCodeToEmailQuery,
  useLazyVerifySecurityCodeQuery,
  useLazyGetClientDetailsQuery,
} = authApiSlice;
